<script setup lang="ts">
import type { Component } from 'vue'
import AccordeonElementalsList from '../../shared/AccordeonElementalsList.vue'
import IconBox from '../../shared/IconBox.vue'
import ElementalItem from '../ElementalItem/index.vue'
import { ElementalListContext } from './ElementalListContext'
import Footer from '@/components/Elemental/ElementalHeaderInfos/index.vue'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import type { Elemental, ElementalTypeEnum } from '~~/src/types/elemental'
import type { List } from '~~/src/types/list'
import type { RecentItem } from '~~/src/types/user'

const props = defineProps<{
  list: Elemental | List | RecentItem
  title: string
  elementals?: Elemental[] | RecentItem[] | null
  elementalsType: ElementalTypeEnum
  iconComponent?: Component
  level?: number
}>()
const user = useUser()
const typeList = getElementalTypeRoute(props.elementalsType)

const listId = typeList
const isOwner = computed(() => {
  return user.value?.id === props.list.user.id
})

const { state } = useElementalListsStore()

const elemetalsFiltred = computed(
  () => {
    if (!props.elementals)
      return props.elementals
    if (!state.query || state.query === '')
      return props.elementals
    return props.elementals.filter(items =>
      items.title.toLowerCase().includes(state.query.toLowerCase())
      || items.id.toString().toLowerCase().includes(state.query.toLowerCase()),
    )
  },
)

watch(elemetalsFiltred, (data) => {
  if (data && state.viewsActives?.[props.elementalsType])
  // @ts-expect-error valid
    state.viewsActives[props.elementalsType].count = data?.length
}, { immediate: true })

const showList = computed(() => state.query === '' || (elemetalsFiltred.value && elemetalsFiltred.value?.length > 0) || props.list.title.toLowerCase().includes(state.query.toLowerCase()))

provide(ElementalListContext, {
  listId,
  onList: true,
  isOwner,
  isFolder: false,
})
</script>

<template>
  <AccordeonElementalsList
    v-show="showList" :list="{
      ...props.list,
      id: `all-${listId}`,
    }" :list-id="listId" :is-main="true" :list-title="title"
    :n-prompts="elemetalsFiltred ? elemetalsFiltred.length : list.nPrompts ?? 0" :elementals-type="elementalsType"
    class="aria-expanded:border-1 border-gray-2"
  >
    <template #icon>
      <slot name="list-icon">
        <IconBox>
          <IconFolder w-4 h-4 />
        </IconBox>
      </slot>
    </template>
    <template #content>
      <div v-if="elemetalsFiltred && elemetalsFiltred.length > 0">
        <template v-for="(item) in elemetalsFiltred" :key="item.id">
          <ElementalItem :elemental="item" />
        </template>
      </div>
      <div v-else class="text-darkGray text-sm text-center p-4  border-1 border-grayLighter rounded-lg">
        no items
      </div>
    </template>
    <template #footer>
      <Footer :elemental="list" :elemetals-filtred="elemetalsFiltred" />
    </template>
  </AccordeonElementalsList>
</template>
